// src/components/layout/TopBar.jsx
//
// 56px white top bar — search input (left), notifications bell, optional
// right slot (e.g. "Raise ticket" CTA on Dashboard / Tickets pages).
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, InputBase, Button, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

export default function TopBar({ rightSlot, notificationCount = 0 }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const onSearchSubmit = (e) => {
    e.preventDefault();
    const q = (new FormData(e.currentTarget).get("q") || "").toString().trim();
    if (q) {
      navigate(`/search?q=${encodeURIComponent(q)}`);
    } else {
      navigate("/search");
    }
  };

  return (
    <Box
      component="header"
      sx={{
        height: 56,
        px: 3.5,
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.brand.border}`,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexShrink: 0,
        position: "relative",
        zIndex: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={onSearchSubmit}
        sx={{
          position: "relative",
          flex: 1,
          maxWidth: 420,
        }}
      >
        <SearchIcon
          sx={{
            position: "absolute",
            left: 12,
            top: "50%",
            transform: "translateY(-50%)",
            color: theme.palette.brand.inkSoft,
            fontSize: 16,
          }}
        />
        <InputBase
          name="q"
          placeholder="Search properties, tickets, documents…"
          fullWidth
          sx={{
            backgroundColor: theme.palette.brand.surfaceMuted,
            border: `1px solid ${theme.palette.brand.border}`,
            color: theme.palette.brand.ink,
            borderRadius: "6px",
            py: "7px",
            pl: "36px",
            pr: "12px",
            fontSize: 13,
            "& input::placeholder": {
              color: theme.palette.brand.inkSoft,
              opacity: 1,
            },
            "&.Mui-focused": {
              borderColor: theme.palette.brand.ink,
              boxShadow: "0 0 0 3px rgba(0,0,0,0.06)",
            },
          }}
        />
      </Box>

      <Box sx={{ flex: 1 }} />

      <Button
        variant="outlined"
        size="small"
        sx={{
          minWidth: 0,
          px: 1.25,
          py: "6px",
          fontSize: 12.5,
          fontWeight: 500,
          color: theme.palette.brand.inkMuted,
          borderColor: theme.palette.brand.border,
          gap: 0.75,
        }}
      >
        <NotificationsOutlinedIcon sx={{ fontSize: 16 }} /> {notificationCount}
      </Button>

      {rightSlot}
    </Box>
  );
}
